import { FC, PropsWithChildren } from 'react';
import { UserType } from '../../store/api/manager-api';
import { RolePermission } from '../../store/api/role-api';
import { useManagerStore } from '../../store/use-manager-store';

export interface HasAccessProps extends PropsWithChildren {
  service: keyof UserType['permissions'];
  permissions: RolePermission[];
}

export const HasAccess: FC<HasAccessProps> = (props) => {
  const { hasAccess } = useManagerStore();
  const { service, permissions } = props;

  if (hasAccess(service, permissions)) {
    return props.children;
  }

  return null;
};
